import { TranscriptTool } from "@/components/tool/TranscriptTool";
import { homepageSeo } from "@/config/seo.config";

export function HomeToolSection() {
  return (
    <section className="mx-auto max-w-2xl px-4 py-8 sm:px-6 sm:py-10">
      <div className="mb-6 max-w-3xl">
        <h1 className="break-words text-3xl font-semibold tracking-normal sm:text-5xl">
          {homepageSeo.h1}
        </h1>
        <p className="mt-3 text-sm leading-5 text-neutral-600 dark:text-neutral-400">
          {homepageSeo.intro}
        </p>
        <p className="mt-2 text-sm font-medium text-neutral-800 dark:text-neutral-200">
          Free to start. No login required.
        </p>
      </div>
      <TranscriptTool />
    </section>
  );
}
